module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 13
// module chunks = 115786611955454 236216132512064 261644322109775